
import './App.css';
import Body from './Components/Body/Body'
import Create from './Components/Create/Create';
import Header from './Components/Header/Header';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './Components/Home';
import Footer from './Components/Footer/Footer';
import Contact from './Components/Contact';
import Upade from './Components/Upade';
import Login from './Components/Login/Login';
import SingUp from './Components/Login/SingUp';

function App() {
  return (
    <>
    
    <Router>
    <Header/>
       <Routes>
          <Route exact path='/' element={<Home/>}/>
          <Route exact path='/create' element={<Create/>}/>
          <Route exact path='/body' element={<Body/>}/>
          <Route exact path='/*' element={<h1>Page not found</h1>}/>
          <Route exact path='/about' element={<Contact/>}/>
          <Route exact path='/update' element={<Upade/>}/>
          <Route exact path='/login' element={<Login/>}/>
          <Route exact path='/signup' element={<SingUp/>}/>
       </Routes>
       <Footer/>
    </Router>
  
  
    </>
  );
}

export default App;
